export const AUTH = 'auth/login'
export const AUTH_CHECK_ACCESS = 'auth/checkAccess'
export const CATEGORY = 'category'
export const PRODUCT = 'product'
export const NEWS = 'news'
export const IMAGE = 'image'